import BaseProxy from "../base-proxy";
import { getAppCustomEnv } from "@/utilities/get-app-custom-env";
import SleekBillingsAPI from "../back-end/sleek-billings-backend/sleek-billings-api";
import axios from "axios";

export default class InvoiceProxy {
  async getCompanyInvoices(input = {}) {
    // TODO: Remove this once we have a proper way to switch to sleek-billings
    // will happen when we totally remove payment/subscription service totally
    const appCustomEnv = await getAppCustomEnv();
    if (appCustomEnv.VUE_APP_SLEEK_BILLING_API) {
      try {
        const response = await axios.get(`${appCustomEnv.VUE_APP_SLEEK_BILLING_API}/api/config`);
        if (response.data.SWITCH_TO_SLEEK_BILLINGS === "enabled") {
          const baseProxy = new SleekBillingsAPI();
          const response = await baseProxy.getInvoicesByCompanyId(input);
          return response.docs;
        }
      } catch (error) {
        console.error("Failed to fetch billing config:", error);
      }
    }

    let query = "";

    if (input.statuses) {
      query += "&" + input.statuses.map((id) => `statuses[]=${id}`).join("&");
    }

    const baseProxy = new BaseProxy();
    const backendUrl = await baseProxy.getPaymentBackendUrl();
    const endpointUrl = `${backendUrl}/invoices?companyId=${input.companyId}${query}`;

    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }
}
